<template>
  <v-row class="link-group">
    <v-col cols="6">
      <v-checkbox
        hide-details
        label="로그인 정보 기억하기"
        v-model="loginIdSaveChecked"
        @change="$emit('changeCheck', $event)"
        on-icon="mdi-check-circle"
        off-icon="mdi-circle-outline"
      >
      </v-checkbox>
    </v-col>
    <v-col cols="6">
      <v-btn text @click="$router.push('/find_pw')">
        아이디/비밀번호 찾기
      </v-btn>
    </v-col>
  </v-row>
</template>
<script>
import Cookies from "js-cookie";
export default {
  props: {
    userData: {
      type: [Object],
    },
  },
  data() {
    return {
      loginIdSaveChecked: true,
    };
  },
  mounted() {
    if (
      Cookies.get("bayerFarmIsSaveLoginId") !== null &&
      Cookies.get("bayerFarmIsSaveLoginId") !== undefined &&
      Cookies.get("bayerFarmIsSaveLoginId") !== ""
    ) {
      this.loginIdSaveChecked = true;
      this.userData.loginId = Cookies.get("bayerFarmIsSaveLoginId");
      this.$emit("changeCheck");
    }
  },
};
</script>
<style lang="scss">
.login {
  .primary--text.mdi-check-circle {
    color: #EF3D33 !important;
  }
}
</style>
